import React from 'react';

import { Image, ImageProps } from '@mantine/core';
import chatLoaderDark from 'assets/gifs/chat-loader-dark.gif';
import chatLoaderLight from 'assets/gifs/chat-loader-light.gif';

interface ChatLoaderProps extends ImageProps {
  isLight?: boolean;
}

export function ChatLoader({ isLight = false, ...imageProps }: ChatLoaderProps) {
  return <Image style={{ width: 20 }} src={isLight ? chatLoaderLight : chatLoaderDark} {...imageProps} />;
}
